module.exports = __webpack_public_path__ + "img/top-img.478950fc.jpg";